import type { ReactElement } from 'react';
import type { IconRenderProps } from '../types';

export function ArrowRightIcon({
	width = 32,
	height = 16,
	color = 'currentColor',
	opacity,
	style,
	...rest
}: IconRenderProps): ReactElement {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 32 16"
			fill="none"
			aria-hidden="true"
			style={{ display: 'block', opacity, ...style }}
			{...rest}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M31.7068 7.29314L24.7068 0.293245C24.3158 -0.0977485 23.6838 -0.0977485 23.2928 0.293245C22.9018 0.684239 22.9018 1.31623 23.2928 1.70722L28.5858 7.00014H0.999992C0.447996 7.00014 0 7.44813 0 8.00012C0 8.55212 0.447996 9.00011 0.999992 9.00011H28.5858L23.2928 14.293C22.9018 14.684 22.9018 15.316 23.2928 15.707C23.4878 15.902 23.7438 16 23.9998 16C24.2558 16 24.5118 15.902 24.7068 15.707L31.7068 8.70711C32.0977 8.31612 32.0977 7.68413 31.7068 7.29314Z"
				fill={color}
			/>
		</svg>
	);
}
